(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fv-international-banner"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-intl-page]').forEach(page=>{
  const show=lang=>{
    page.querySelectorAll('[data-intl-panel]').forEach(panel=>panel.hidden=panel.dataset.intlPanel!==lang);
    page.querySelectorAll('[data-intl-lang]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.intlLang===lang)));
  };
  page.querySelectorAll('[data-intl-lang]').forEach(button=>button.addEventListener('click',()=>show(button.dataset.intlLang)));
  show(page.dataset.initialLanguage || 'es');
});
if(!customElements.get('fv-courier')){
customElements.define('fv-courier',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;
    this.ready=true;
    this.choice=this.querySelector('[data-courier-choice]');
    this.ack=this.querySelector('[data-courier-ack]');
    this.choice.checked=this.dataset.selected==='Yes';
    this.sync(this.choice.checked,false);
    this.addEventListener('change',()=>{
      document.querySelectorAll('fv-courier').forEach(el=>el.sync(this.choice.checked,this.ack.checked));
    });
  }
  sync(selected,accepted){
    if(!this.choice)return;
    this.choice.checked=selected;
    this.ack.checked=selected&&accepted;
    this.ack.required=selected;
    this.ack.disabled=!selected;
    this.querySelector('[data-courier-notice]').hidden=!selected;
    this.querySelector('[data-courier-value]').value=selected?'Yes':'No';
    this.querySelector('[data-courier-record]').value=selected&&accepted?'Acknowledged U.S. courier delivery terms - 2026-09-06':'';
  }
});
}
  } catch(e) { console.error(e); }
})();

})();
